import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TCardId, TChecklistId } from '../../../../../../../../types/types';
import { IChecklistItem } from '../../../../../../../../store/model/checklists/checklist/types';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { SegmentChecklistOptionsValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { getChecklistItems } from '../../../../../../../../store/model/checklists/checklist/selectors/getChecklistItems';

export const onDeleteChecklist = (
    cardId: TCardId,
    checklistId: TChecklistId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const checklistItems = getChecklistItems(state, cardId, checklistId) || {};
        const checklistItemsCount = Object.keys(checklistItems).length;
        if (!checklistItemsCount) {
            dispatch(segmentTrackAction(SegmentCardEvent.CHECKLIST_WITHOUT_ITEMS_DELETED))
        } else {
            dispatch(segmentTrackAction(SegmentCardEvent.CHECKLIST_WITH_ITEMS_DELETED, {
                name: SegmentChecklistOptionsValue.COUNT,
                value: checklistItemsCount
            }));
        }
    };
    return action;
};
